import script from "./Splitscreen16167.vue?vue&type=script&setup=true&lang=ts"
export * from "./Splitscreen16167.vue?vue&type=script&setup=true&lang=ts"

import "./Splitscreen16167.vue?vue&type=style&index=0&id=0cd04ab6&lang=scss"
import "./Splitscreen16167.vue?vue&type=style&index=1&id=0cd04ab6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cd04ab6"]])

export default __exports__